export enum TransactionFilterSteps {
  FilterMain = 'filter-main',
  FilterAsset = 'filter-asset',
  FilterType = 'filter-type',
  FilterStatus = 'filter-status',
}
